import { Button, Card, message } from 'antd';
import React from 'react'
import { useNavigate } from 'react-router';
import not_allow from '../../assets/user-not-allow/user_not_allow.png';
import ResponseMessage from '../../components/Comman/Notification/ResponseMessge';

const NotAllowPage = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
  
      localStorage.removeItem("userData");
          localStorage.removeItem("isLoggedIn");
          navigate("/")
          window.location.reload(); 
          ResponseMessage.success({ message: 'Logout Successful.' })
          // message.success("Logout Successful.");
    };
  
    const containerStyle = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      backgroundColor: '#f0f2f5',
    };
  
    const cardStyle = {
      width: '400px',
      textAlign: 'center',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    };
  
    const imageStyle = {
      width: '100%',
      height: 'auto',
      marginBottom: '16px',
    };
  
    const contentStyle = {
      padding: '16px',
    };
  
    const headingStyle = {
      marginBottom: '8px',
    };
  
    const paragraphStyle = {
      marginBottom: '16px',
      color: '#666',
    };
  
    return (
      <div style={containerStyle}>
        <Card style={cardStyle} hoverable>
          <img
            src={not_allow} 
            alt="Not Allowed"
            style={imageStyle}
          />
          <div style={contentStyle}>
            <h2 style={headingStyle}>Access Denied</h2>
            <p style={paragraphStyle}>You do not have permission to view this page.</p>
            <Button type="primary" onClick={handleLogout}>Go Back to Login</Button>
          </div>
        </Card>
      </div>
    );
  };
  
  export default NotAllowPage;